import appConfig from "config.json";

const { cache } = appConfig;
const openCacheStorage = async () => {
	try {
		return await caches?.open(cache.name);
	} catch (error) {
		console.log(error);
	}
	return null;
};

export const validateCache = async (cacheStorage, key) => {
	if (cacheStorage && key) {
		try {
			const cacheResult = (await cacheStorage?.match(key)) || null;
			if (cacheResult) {
				const expirationDate = Date.parse(
					cacheResult.headers.get(cache.expirationHeader)
				);
				if (expirationDate < new Date()) {
					await cacheStorage.delete(key);
					return null;
				}
			}
			return cacheResult;
		} catch (error) {
			console.log(error);
		}
	}
	return null;
};

export const getCache = async (key) => {
	if (key) {
		const cacheStorage = await openCacheStorage();
		if (cacheStorage) {
			return await validateCache(cacheStorage, key);
		}
	}
	return null;
};

export const setCache = async (key, response, cacheValidMinutes = 5) => {
	if (key && response) {
		try {
			const cacheStorage = await openCacheStorage();
			if (cacheStorage) {
				let expireTime = "";
				if (cacheValidMinutes === -1) {
					const headers = response.headers;
					expireTime = headers.get("Expires") || headers.get("expires");
				} else {
					const expires = new Date();
					const seconds = 60;
					expires.setSeconds(
						expires.getSeconds() + cacheValidMinutes * seconds
					);
					expireTime = expires.toUTCString();
				}
				if (expireTime) {
					const cachedResponseFields = {
						status: response.status,
						statusText: response.statusText,
						headers: {
							[cache.expirationHeader]: expireTime,
						},
					};
					response.headers.forEach((v, k) => {
						cachedResponseFields.headers[k] = v;
					});
					await cacheStorage.put(
						key,
						new Response(response.body, cachedResponseFields)
					);
				}
			}
		} catch (error) {
			console.log(error);
		}
	}
};

export const cleanExpiredCache = async () => {
	try {
		const cacheStorage = await openCacheStorage();
		cacheStorage?.keys().then((keyList) => {
			for (let index = 0; index < keyList.length; index++) {
				validateCache(cacheStorage, keyList[index].url);
			}
		});
	} catch (error) {
		console.error(error);
	}
};

/**
 * Deletes every cache entry whose key URL contains the given substring.
 * Useful for invalidating a group of related entries (e.g. all per-user
 * variants of a single endpoint) regardless of their query parameters.
 */
export const deleteCacheByUrlMatch = async (match) => {
	if (!match) return;
	try {
		const cacheStorage = await openCacheStorage();
		if (!cacheStorage) return;
		const keyList = await cacheStorage.keys();
		await Promise.all(
			keyList
				.filter((request) => request.url.includes(match))
				.map((request) => cacheStorage.delete(request))
		);
	} catch (error) {
		console.error(error);
	}
};
